import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import front from '@/../static/js/proto/CtpFront';
import * as ConditionData from '../../ConditionData';
import * as format from '@/utils/format';
import * as utils from '@/utils/utils';
import _ from 'lodash';
/**
 * 未触发条件单
 */
@Component({
})
export default class ConditionTriggered extends Vue {

  public conditionTriggeredList: IOrderConditional[] = [];
  public showFeedbackToast = false;
  public feedbackMessage = '';
  public feedbackType = 'success';
  public feedbackToastTimer = null;
  private conditionSuberId = 'condition_triggered_page';
  private hasConditionSub = false;
  private isActive = false;
  private autoRefreshTimer: any = null;
  private hasPendingAutoRefresh = false;
  private lastRefreshAt = 0;
  private queryToken = 0;
  private selectedQuickKey: string | null = null;
  private applyingQuickRange = false;
  private quickApplyTimer: any = null;
  private lastQuickAppliedAt = 0;
  public formFind = {
    start: (new Date()),
    end: (new Date()),
  };
  public selectedState = front.con_order_trigger;

  public tabState = {
    已触发: front.con_order_trigger,
    已删除: front.con_order_delete,
    已结算: front.con_order_settlement,
  };
  public tableData: any[] = [];

  public get findStart() {
    return format.formatDate(this.formFind.start);
  }
  public get findEnd() {
    return format.formatDate(this.formFind.end);
  }

  public tableTitle: IFixedTableTitle[] = [
    {
      text: '合约',
      width: '2rem',
      name: 'contract',
    },
    {
      text: '触发时间',
      width: '3.5rem',
      name: 'triggerTime',
    },
    {
      text: '状态',
      width: '1.5rem',
      name: 'state',
    },
    {
      text: '条件',
      width: '1.5rem',
      name: 'condition',
    },
    {
      text: '下单',
      width: '3rem',
      name: 'order',
    },
    {
      text: 'ID',
      width: '6rem',
      name: 'id',
    }];
  public sheetVisible: boolean = false;
  public typeData: string = '全部';
  public filtFlage: boolean = true;
  public orderType: number = 0;
  public actionData: any[] = [
    {
      name: '全部',
      font: '&#xe623;',
      font02: '&#xe626;',
    }, {
      name: '云条件单',
      font: '&#xe623;',
      font02: '&#xe626;',
    }, {
      name: '止盈止损单',
      font: '&#xe623;',
      font02: '&#xe626;',
    }];
  public quickRangeOptions = [
    {
      key: 'today',
      name: '今日',
    },
    {
      key: 'thisWeek',
      name: '本周',
    },
    {
      key: 'thisMonth',
      name: '本月',
    },
    {
      key: 'last3',
      name: '近3天',
    },
    {
      key: 'last7',
      name: '近7天',
    },
    {
      key: 'last30',
      name: '近30天',
    },
  ];
  public selectIndex: string = '0';
  // public get tableData() {
  //   const arr: any[] = [];
  //   for (const item of this.conditionTriggeredList) {
  //     console.log(item);
  //     if ((item as any).orderType === 0) {
  //       if (item.state === this.selectedState) {
  //         arr.push({
  //           contract: item.targetId,
  //           state: ConditionData.
  //             getText(ConditionData.con_active_state, item.state),
  //           condition: ConditionData.getCondition(item),
  //           order: ConditionData.getOrder(item),
  //           id: item.id,
  //           triggerTime: (item.triggerDate + '').
  //             replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
  //             + (item.triggerTime + '').replace(/\..*/, ''),
  //         });
  //       }
  //     }
  //   }
  //   return _.orderBy(arr, ['triggerTime'], ['desc']);
  // }

  public deactivated() {
    this.isActive = false;
    utils.closeIndicator();
  }
  public beforeDestroy() {
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
      this.feedbackToastTimer = null;
    }
    if (this.autoRefreshTimer) {
      clearTimeout(this.autoRefreshTimer);
      this.autoRefreshTimer = null;
    }
    if (this.quickApplyTimer) {
      clearTimeout(this.quickApplyTimer);
      this.quickApplyTimer = null;
    }
    if (this.hasConditionSub) {
      front.conditionOrderUnsub(this.conditionSuberId);
      this.hasConditionSub = false;
    }
  }
  public openFeedbackToast(message, type = 'error', duration = 2000) {
    this.feedbackMessage = message;
    this.feedbackType = type;
    this.showFeedbackToast = true;
    if (this.feedbackToastTimer) {
      clearTimeout(this.feedbackToastTimer);
    }
    this.feedbackToastTimer = setTimeout(() => {
      this.showFeedbackToast = false;
      this.feedbackToastTimer = null;
    }, duration) as any;
  }
  public mounted() {
    this.initConditionSub();
    this.refreshData(true);
  }
  public activated() {
    this.isActive = true;
    utils.closeIndicator();
    const now = Date.now();
    if (this.hasPendingAutoRefresh || now - this.lastRefreshAt > 1200) {
      this.refreshData(true);
    }
  }
  @Watch('formFind.start')
  public handleStartDateChange(value) {
    if (!this.shouldIgnoreQuickRangeClear()) {
      this.selectedQuickKey = null;
    }
    const normalized = this.normalizeDate(value);
    if (normalized.getTime() !== value.getTime()) {
      this.formFind.start = normalized;
    }
  }
  @Watch('formFind.end')
  public handleEndDateChange(value) {
    if (!this.shouldIgnoreQuickRangeClear()) {
      this.selectedQuickKey = null;
    }
    const normalized = this.normalizeDate(value);
    if (normalized.getTime() !== value.getTime()) {
      this.formFind.end = normalized;
    }
  }
  private shouldIgnoreQuickRangeClear() {
    if (this.applyingQuickRange) {
      return true;
    }
    return Date.now() - this.lastQuickAppliedAt < 500;
  }
  public normalizeDate(value) {
    const date = value ? new Date(value) : new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }
  public offsetDate(baseDate, offsetDays) {
    const date = new Date(baseDate.getTime());
    date.setDate(date.getDate() + offsetDays);
    return this.normalizeDate(date);
  }
  public startOfWeek(baseDate) {
    const date = this.normalizeDate(baseDate);
    const day = date.getDay();
    const diff = (day + 6) % 7;
    return this.offsetDate(date, -diff);
  }
  public startOfMonth(baseDate) {
    const date = this.normalizeDate(baseDate);
    return new Date(date.getFullYear(), date.getMonth(), 1);
  }
  public getQuickRangeRange(key) {
    const today = this.normalizeDate(new Date());
    switch (key) {
      case 'today':
        return {
          start: today,
          end: today,
        };
      case 'thisWeek':
        return {
          start: this.startOfWeek(today),
          end: today,
        };
      case 'thisMonth':
        return {
          start: this.startOfMonth(today),
          end: today,
        };
      case 'last3':
        return {
          start: this.offsetDate(today, -2),
          end: today,
        };
      case 'last7':
        return {
          start: this.offsetDate(today, -6),
          end: today,
        };
      case 'last30':
        return {
          start: this.offsetDate(today, -29),
          end: today,
        };
      default:
        return null;
    }
  }
  public isSameDate(left, right) {
    return left.getFullYear() === right.getFullYear()
      && left.getMonth() === right.getMonth()
      && left.getDate() === right.getDate();
  }
  public isQuickRangeActive(key) {
    return this.selectedQuickKey === key;
  }
  public handleQuickRange(key) {
    const range = this.getQuickRangeRange(key);
    if (!range) {
      return;
    }
    this.selectedQuickKey = key;
    this.lastQuickAppliedAt = Date.now();
    this.applyingQuickRange = true;
    if (this.quickApplyTimer) {
      clearTimeout(this.quickApplyTimer);
      this.quickApplyTimer = null;
    }
    this.formFind.start = range.start;
    this.formFind.end = range.end;
    this.quickApplyTimer = setTimeout(() => {
      this.applyingQuickRange = false;
      this.quickApplyTimer = null;
    }, 600) as any;
  }
  private initConditionSub() {
    if (this.hasConditionSub) {
      return;
    }
    const subject = front.conditionOrderSub({
      suberId: this.conditionSuberId,
      publish: this.handleConditionOrderPublish,
      reject: (err) => console.error(err),
    });
    this.hasConditionSub = !!subject;
  }
  private handleConditionOrderPublish = (order: IOrderConditional) => {
    if (!order) {
      return;
    }
    if (
      order.state !== front.con_order_trigger &&
      order.state !== front.con_order_delete &&
      order.state !== front.con_order_settlement
    ) {
      return;
    }
    this.hasPendingAutoRefresh = true;
    this.scheduleAutoRefresh();
  }
  private scheduleAutoRefresh() {
    if (!this.isActive) {
      return;
    }
    if (this.autoRefreshTimer) {
      return;
    }
    this.autoRefreshTimer = setTimeout(() => {
      this.autoRefreshTimer = null;
      if (!this.isActive) {
        return;
      }
      this.refreshData(true);
    }, 600) as any;
  }
  private refreshData(silent: boolean) {
    if (this.formFind.end.getTime() < this.formFind.start.getTime()) {
      if (!silent) {
        this.openFeedbackToast('查询条件错误: 结束日期不能早于开始日期', 'error', 2400);
      }
      return;
    }
    this.lastRefreshAt = Date.now();
    this.hasPendingAutoRefresh = false;
    if (!silent) {
      utils.indicator('正在查询');
    }
    this.queryData()
      .then(() => {
        if (!silent) {
          utils.closeIndicator();
        }
      })
      .catch(() => {
        if (!silent) {
          utils.closeIndicator();
        }
      });
  }
  public queryData() {
    const token = ++this.queryToken;
    this.tableData = [];
    return new Promise((resolve, reject) => {
      // utils.clearArr(this.conditionTriggeredList);
      front.conditionOrderQry('', '',
        this.findStart.replace(/[\-]/g, ''),
        this.findEnd.replace(/[\-]/g, ''),
        data => {
          if (token !== this.queryToken) {
            return;
          }
          let conditionData: any = '';
          if ((data as any).orderType === 0) {
            conditionData = ConditionData.getCondition(data);
          } else {
            if (data.direction === 1) {
              conditionData = ConditionData.getCondition(data);
            } else {
              conditionData = ConditionData.getConditions(data);
            }
          }
          // const conditionData = (data as any).orderType === 0 ? ConditionData.getCondition(data) : ConditionData.getConditions(data);
          // console.log('triggered', data, data.state);
          if (this.filtFlage) {
            this.tableData.push({
              contract: data.targetId,
              state: ConditionData.
                getText(ConditionData.con_active_state(), data.state),
              condition: conditionData,
              order: ConditionData.getOrder(data),
              id: data.id,
              triggerTime: (data.updateDate + '').
                replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
                + (data.updateTime + '').replace(/\..*/, ''),
            });
          } else {
            if ((data as any).orderType === this.orderType) {
              this.tableData.push({
                contract: data.targetId,
                state: ConditionData.
                  getText(ConditionData.con_active_state(), data.state),
                condition: conditionData,
                order: ConditionData.getOrder(data),
                id: data.id,
                triggerTime: (data.updateDate + '').
                  replace(/(\d{4})(\d{2})(\d{2})/, '$1-$2-$3') + ' '
                  + (data.updateTime + '').replace(/\..*/, ''),
              });
            }
          }
          this.tableData.sort(function (a, b) {
            return b.triggerTime > a.triggerTime ? 1 : -1;
          });
          resolve();
        }, err => {
          if (token !== this.queryToken) {
            return;
          }
          if (err.message !== '查询返回为空. ecmsg:成功') {
            this.openFeedbackToast('查询云条件单失败: ' + err.message, 'error', 2600);
          }
          reject(err);
        });
    });
  }
  public handleQuery() {
    this.refreshData(false);
  }
  // 选取条件单类型
  public handleSelectType(index) {
    this.selectIndex = index;
    if (index === 0) {
      this.filtFlage = true;
    } else if (index === 1) {
      this.filtFlage = false;
      this.orderType = 0;
    } else if (index === 2) {
      this.filtFlage = false;
      this.orderType = 1;
    }
    this.refreshData(true);
  }
}



// WEBPACK FOOTER //
// ./src/views/condition/components/ConditionTriggered/ConditionTriggered.ts